const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_URL = BASE_URL.endsWith('/api/v1') ? BASE_URL : BASE_URL + '/api/v1';

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('accessToken');
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

export const walletService = {
  async getBalance(): Promise<number> {
    const res = await fetch(`${API_URL}/payment/wallet`, { headers: authHeaders() });
    if (!res.ok) throw new Error('Failed to fetch wallet balance');
    const data = await res.json();
    return data.balance || 0;
  },

  /** Kicks off a Paystack top-up; funds land in the same SafariCab Paystack
   * account as ride card payments/driver commission. Actual crediting happens
   * server-side via the /payment/webhook handler once Paystack confirms. */
  async initializeTopUp(amount: number, email: string, riderId: string, callbackUrl?: string) {
    const res = await fetch(`${API_URL}/payment/initialize`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({
        email, amount,
        metadata: { reason: 'wallet_topup', rider_id: riderId },
        ...(callbackUrl ? { callback_url: callbackUrl } : {}),
      }),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.message || 'Failed to start top-up');
    return data as { authorization_url: string; access_code: string; reference: string };
  },

  /** Client-side confirmation ping so the UI can refresh promptly - the wallet
   * balance itself is only ever updated by the webhook, not by this call. */
  async verifyTopUp(reference: string): Promise<boolean> {
    const res = await fetch(`${API_URL}/payment/verify/${reference}`, { headers: authHeaders() });
    const data = await res.json();
    return data?.data?.status === 'success';
  },
};
